module.exports = __webpack_public_path__ + "img/animated.7585bdb0.gif";